import Utils from "@/mixins/Utils";
import planningService from "@/services/planning";
export default {
  mixins: [Utils],
  props: {
    intervention: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      spinner_variable: {
        spinnerMounted: false,
      },
    };
  },
  methods: {
    save() {
      const vue = this;
      this.$validator.validateAll().then(async (result) => {
        vue.spinner_variable.spinnerMounted = true;
        await planningService
          .deleteModificationRequest(vue.intervention.id, {
            message: vue.intervention.message,
          })
          .then((res) => {
            if (res.success) {
              vue.spinner_variable.spinnerMounted = false;
              vue.callToaster(vue.$t("modification-saved"));
              vue.$emit("saved");
            } else {
              vue.callToaster(response.data.message);
            }
          })
          .catch((err) => {
            vue.callToaster(vue.$t("problem-arise"));
          });
      });
    },
  },
};
